import { Box, Dialog, Grid, TextField, Typography } from "@mui/material";
import { useCallback, useState } from "react";
import useStyles from '../../../styles/global-mui.js'
import DsasButton from "../DsasButton/DsasButton.js";
import { isAdminDSAS } from "../../../actions/auth.js";

export function ExportDialog({ onClose, open, url }) {

  const classes = useStyles();

  const [width, setWidth] = useState(600);
  const [height, setHeight] = useState(900);

  const handleClose = () => {
    onClose();
  };

  const isButtonDisabled = useCallback(() => {
    return isNaN(width) || isNaN(height);
  }, [width, height]);

  const onCopyIframeSmartScroll = () => {
    if (navigator.clipboard && url) {

      const responsiveIframe = 
          '<script src="https://cdnjs.cloudflare.com/ajax/libs/iframe-resizer/4.3.6/iframeResizer.min.js"></script>' +
          '<script>if(!window._rsz){window._rsz = function () {' +
            'let scrollPending = false;' +
            'let lastIframe = null;' +
            'iFrameResize({' +
              'checkOrigin: false,' +
              'interval: 100,' +
              'messageCallback: function(messageData) {' +
                'const message = messageData.message;' +
                'const iframe = messageData.iframe;' +
                'if (!message) return;' +
                'if (message.type === "scrollToTop") {' +
                  'scrollPending = true;' +
                  'lastIframe = iframe;' +
                '}' +
                'if (message.type === "scrollToTopReady" && scrollPending && iframe === lastIframe) {' +
                  'setTimeout(() => {' +
                    'window.scrollTo({' +
                      'top: iframe.offsetTop,' +
                      'behavior: "smooth"' +
                    '});' +
                    'scrollPending = false;' +
                    'lastIframe = null;' +
                  '}, 50);' +
                '}' +
              '}' +
            '});' +
          '};if(document.readyState!="loading"){_rsz()}else{document.addEventListener("DOMContentLoaded",_rsz)}}<\/script>' +
          '<iframe src="' + url + '" style="display: block; width: 100%; overflow: auto; margin: auto; border-width: 0px;" scrolling="no"></iframe>';

      navigator.clipboard.writeText(responsiveIframe);
    }
  };

  const onCopyIframe = () => {
    if (navigator.clipboard && url) {

      let responsiveIframe = '<script src="https://cdnjs.cloudflare.com/ajax/libs/iframe-resizer/4.3.6/iframeResizer.min.js"></script>' +
        '<script>if(!window._rsz){window._rsz=function(){var i=iFrameResize({checkOrigin:false,interval:100});};if(document.readyState!="loading"){_rsz()}else{document.addEventListener("DOMContentLoaded",_rsz)}}</script>' +
        '<iframe src="' + url + '" style="display: block; width: 100%; overflow: auto; margin: auto; border-width: 0px;" scrolling="no"></iframe>';

      navigator.clipboard.writeText(responsiveIframe);
    }
  };

  const onCopyURL = () => {
    if (navigator.clipboard && url) {
      navigator.clipboard.writeText(url);
    }
  };

  return (
    <Dialog onClose={handleClose} open={open} className={classes.customPopup}
     BackdropProps={{
      sx: {
         backgroundColor: 'rgba(109, 110, 115, 0.6)', // <-- équivalent à #6D6E73 à 60%
      }
    }}
    >
       {/* Bouton de fermeture */}
              <Box
                sx={{
                  position: 'absolute',
                  top: '1rem',
                  right: '1rem',
                  width: '16px',
                  height: '16px',
                  borderRadius: '50%',
                  border: '2px solid var(--color-blue-secondary)', // Cercle fin
                  backgroundColor: 'var(--color-white)', // Fond blanc
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  cursor: 'pointer',
                  zIndex: 1,
                  '&:hover': {
                    backgroundColor: 'var(--color-white)',
                  },
                }}
                onClick={handleClose}
              >
                <Box
                  component="span"
                  sx={{
                    fontSize: '14px',
                    fontWeight: 600,
                    lineHeight: 1,
                    color: 'var(--color-blue-secondary)',
                  }}
                >
                  ×
                </Box>
              </Box>

      <Box alignItems="center" textAlign={"center"} className='medium-padding'>
       <Typography variant='h2' className='popupTitle'>Options avancées</Typography>

        <Grid container spacing={2} className='medium-padding'>
                 <Grid item xs={6}>
                   <TextField 
                     label="Largeur" 
                     variant="standard" 
                     sx={{ width: '100%',
                      '& .MuiInputLabel-root':{
                        // color: 6d6f...
                      },
                       '& .MuiInput-underline:before': {
                         borderBottom: '1px solid var(--color-light-grey)',
                       },
                       '& .MuiInput-underline:after': {
                           borderBottom: '1px solid var(--color-medium-grey)',
                         }
                     }}
                     name="width" 
                     value={width} 
                     onChange={(e) => setWidth(e.target.value)}>
                   </TextField>
                 </Grid>
                 <Grid item xs={6}>
                   <TextField
                     label="Hauteur"
                     variant="standard" 
                     sx={{ width: '100%',
                       '& .MuiInput-underline:before': {
                         borderBottom: '1px solid var(--color-light-grey)',
                       },
                       '& .MuiInput-underline:after': {
                           borderBottom: '1px solid var(--color-medium-grey)',
                         }
                     }} 
                     name="height" 
                     value={height} 
                     onChange={(e) => setHeight(e.target.value)}>
                     </TextField>
                 </Grid>
               </Grid>
               </Box>
        <Box className='large-separator'></Box>
        
        <Box className='centered-wrapper'>
          <DsasButton variant='secondary' label="Copier en tant qu'IFRAME" onClick={onCopyIframe} disabled={isButtonDisabled()}></DsasButton>
        </Box>

        {isAdminDSAS() && <Box className='centered-wrapper'>
                  <DsasButton variant='secondary' label="Copier en tant qu'IFRAME AVEC SCROLL INTELLIGENT" onClick={onCopyIframeSmartScroll} disabled={isButtonDisabled()}></DsasButton>
        </Box>}
        
        <Box className='large-separator'></Box>
        
        <Box className='centered-wrapper'>
          <DsasButton variant='secondary' label="Copier l'URL" onClick={onCopyURL}></DsasButton>
        </Box>
      
    </Dialog>
  );
}